__turbopack_context__.v({
  "isDisabled": "slider-module-scss-module__ocQfjW__isDisabled",
  "slider": "slider-module-scss-module__ocQfjW__slider",
  "sliderContainer": "slider-module-scss-module__ocQfjW__sliderContainer",
});
